import {useNavigate, useNavigation, useParams, useRouteLoaderData} from 'react-router-dom'
import React, {useState} from 'react'
import {Modal} from 'antd'
import {PlantRouteLoaderData} from '../App'
import {ToDoForm} from './ToDoForm'
import {useMousePositionContext} from '../plantForm/usePlantModalMousePosition'
import {ToDo} from '../../entities/todoList'
import {CustomToDoType, ToDoType} from '../../entities/journalRecord'
import {PlantCollection} from '../../entities/plant'

export type ToDoModalProps = {
  routeWhenClosed: string
  unfinishedToDos: ToDo[]
  toDoTypes: CustomToDoType[]
  userEventTypes
}

export function ToDoModal({
  routeWhenClosed,
  unfinishedToDos,
  toDoTypes,
  userEventTypes,
}: ToDoModalProps) {
  const navigation = useNavigation()
  const navigate = useNavigate()
  const [isLoading, setLoading] = useState(false)
  const routeParams = useParams()
  const {mousePosition} = useMousePositionContext()

  const toDoPopupVisible = Boolean(routeParams.todoId) && !routeParams.plantId
  const plantLoading = toDoPopupVisible && navigation.state === 'loading'

  const {plantedPlantsNamesWithId, userPlantCollections, userPlantCollectionsWithPlantsIds} =
    useRouteLoaderData('todos') as {
      plantedPlantsNamesWithId: {id: number; name: string}[]
      userPlantCollections: PlantCollection[]
      userPlantCollectionsWithPlantsIds: any
    }

  const toDoId = Number(routeParams.todoId)
  const plantId = Number(routeParams.plantId)

  const onClose = () => navigate(routeWhenClosed)

  const closeModal = () => {
    navigate(routeWhenClosed)
  }

  return (
    <Modal
      className="todo-modal"
      open={toDoPopupVisible}
      onCancel={onClose}
      mousePosition={mousePosition || undefined}
      footer={null}
      destroyOnHidden
      width={800}
      loading={isLoading}
    >
      <ToDoForm
        currentToDo={unfinishedToDos.find((todo) => todo.id === toDoId)}
        plantedPlantsNamesWithId={plantedPlantsNamesWithId}
        toDoTypes={toDoTypes}
        userEventTypes={userEventTypes}
        closeModal={closeModal}
        setLoading={setLoading}
        isFullForm={false}
        userPlantCollections={userPlantCollections}
        userPlantCollectionsWithPlantsIds={userPlantCollectionsWithPlantsIds}
      />
    </Modal>
  )
}
